import React from 'react';
import { useTranslation } from 'react-i18next';
import { AccountType } from '../../types/AccountType';

interface AccountTypeToggleProps {
  providerType: AccountType;
  onChange: (type: AccountType) => void;
}

const AccountTypeToggle: React.FC<AccountTypeToggleProps> = ({ providerType, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center my-6 gap-0" data-testid="account-type-toggle">
      <button
        onClick={() => onChange(AccountType.Personal)}
        className={`font-RoobertPRO text-base font-medium uppercase w-1/2 border border-primary-2 rounded-l-md py-2 transition -mr-px ${
          providerType === AccountType.Personal ? 'bg-primary-2 text-primary-3' : 'text-gray-700 cursor-pointer'
        }`}
      >
        {t(AccountType.Personal)}
      </button>
      <button
        onClick={() => onChange(AccountType.Business)}
        className={`font-RoobertPRO text-base font-medium uppercase w-1/2 border border-primary-2 rounded-r-md py-2 transition ${
          providerType === AccountType.Business ? 'bg-primary-2 text-primary-3' : 'text-gray-700 cursor-pointer'
        }`}
      >
        {t(AccountType.Business)}
      </button>
    </div>
  );
};

export default AccountTypeToggle;
